/*
 * ingredient-filter.js — the product filter above the Ingredients page grid.
 *
 * PURE ENHANCEMENT. ingredient-grid.liquid renders the control inside a
 * wrapper that starts `hidden`, so with no script the page shows every
 * ingredient and offers no control that would not work. This reveals it and,
 * on change, hides every card whose `data-ingredient-products` (the handles of
 * the products listing that ingredient in `refined.ingredients`) lacks the
 * chosen product. "all" shows every card. Text and the `hidden` attribute only;
 * no Tailwind class names (`source(none)` does not scan .js).
 */

const FILTER_SELECTOR = '[data-ingredient-filter]'
const CARD_SELECTOR = '[data-ingredient-card]'

const bound = new WeakSet()

function apply(scope, value) {
  for (const card of scope.querySelectorAll(CARD_SELECTOR)) {
    const products = (card.getAttribute('data-ingredient-products') || '').split(' ')
    card.hidden = value !== 'all' && !products.includes(value)
  }
}

function bindFilter(wrapper) {
  if (bound.has(wrapper)) return
  const select = wrapper.querySelector('select')
  if (!select) return
  bound.add(wrapper)

  const scope = wrapper.closest('section') || document
  select.addEventListener('change', () => apply(scope, select.value))
  /* A restored page (back button) can arrive with a non-default choice. */
  apply(scope, select.value)
  wrapper.hidden = false
}

function initAll(root) {
  for (const wrapper of root.querySelectorAll(FILTER_SELECTOR)) bindFilter(wrapper)
}

initAll(document)

/* The theme editor swaps section markup in and out with no page load. */
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
